<template>
  <div class="top-panel">
    <search-input/>

    <user-panel/>
  </div>
</template>

<script>
import UserPanel from './UserPanel.vue';
import SearchInput from './SearchInput.vue';

export default {
  name: 'top-panel',

  components: {
    UserPanel,
    SearchInput,
  },
};
</script>

<style lang="scss" scoped>
.top-panel {
  width: 100%;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--main-brand-color);
  box-sizing: border-box;
  padding: 0 20px;
  z-index: 99;
  position: relative;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.4);
}
</style>
